import { createAsyncThunk } from "@reduxjs/toolkit";
import { IAPIResponse, IProduct } from "../../types/api";
import { getProducts as getProductsFromAPI } from "../../lib/api";

interface IGetProductsResponse extends IAPIResponse {
    products: IProduct[];
}

export const getProducts = createAsyncThunk<
    IGetProductsResponse,
    void,
    { rejectValue: string }
>("shop/getProducts", async (_, { rejectWithValue, dispatch }) => {
    try {
        const response = await getProductsFromAPI();

        return response;
    } catch (e) {
        const error = e as string;
        // dispatch(
        //     alertActions.error({
        //         level: "danger",
        //         text: "Login failed. Please try again",
        //         title: error,
        //     }),
        // );
        return rejectWithValue(error);
    }
});
